<app-navbar class="navbar-bg"></app-navbar>

<router-outlet></router-outlet>

<app-footer [mode]="footerMode"></app-footer>
